import React from "react";
import Styled, { CustomModal, LineBreak } from "./styles";
import Fragment from "react-dot-fragment";

const getInvestorType = name => {
  if (name === "Prudent Bank") {
    return "Commercial Bank";
  }

  if (name === "Mezz Capital") {
    return "Mezzanine Lender";
  }

  if (name === "Great White Financials") {
    return "Sharky Sparky";
  }

  return "";
};

const ModalExhibit5 = ({ debtClients, goBack }) => (
  <CustomModal goBack={goBack}>
    <b>EXHIBIT 5 - Lenders' Terms & Conditions</b>
    <LineBreak />
    <Styled.ModalTable>
      <tbody>
        <tr>
          <th>Investor Type</th>
          <th>Investor Name</th>
          <th>Loan Term (in years)</th>
          <th>Borrowing Limit (Debt to Capital Ratio Limit)</th>
          <th>Profit Spread (100 bps = 1%)</th>
        </tr>
        {debtClients.map(debtClient => (
          <Fragment key={debtClient.id}>
            <tr>
              <td>{getInvestorType(debtClient.name)}</td>
              <td>{debtClient.name}</td>
              <td>8</td>
              <td>{debtClient.lt_debt_to_capital}</td>
              <td>{debtClient.lt_company_spread * 10000} bps</td>
            </tr>
          </Fragment>
        ))}
      </tbody>
    </Styled.ModalTable>
    <LineBreak />* Starting Year 2, Great White Financials can lend,
    at minimum, $15M, irrespective of your debt to capital ratio
  </CustomModal>
);

export default ModalExhibit5;



// WEBPACK FOOTER //
// ./src/components/bcase/ModalExhibit5.js